import { render, staticRenderFns } from "./FindInvestors.vue?vue&type=template&id=b29511de"
import script from "./FindInvestors.vue?vue&type=script&lang=js"
export * from "./FindInvestors.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/admin/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./FindInvestors.vue?vue&type=style&index=1&id=b29511de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports